<div class="max-w-2xl mx-auto p-6 rounded-lg">
    <h3 class="titre3">{{ 'USERS_MANAGEMENT.CONFIRM_PASSWORD_CHANGE' | translate }}</h3>
    <div class="mb-4">
        <p>{{ 'USERS_MANAGEMENT.PASSWORD_FORCED_SUCCESS_1' | translate }}<strong>{{ email }}</strong>{{ 'USERS_MANAGEMENT.PASSWORD_FORCED_SUCCESS_2' | translate }}</p>
        <p>{{ 'USERS_MANAGEMENT.NEW_PASSWORD_IS' | translate }} <strong>{{ password }}</strong></p>
    </div>
    <div class="flex justify-end">
        <button (click)="onClose()" type="button"
            class="px-4 py-2 btn-primary-novo">
            {{ 'USERS_MANAGEMENT.CLOSE' | translate }}
        </button>
    </div>
</div>
